export const isEmpty = <Value,>(array: Array<Value>): boolean =>
  array.length === 0
